<template>
  <span class="task-tag" v-if="tag">
    {{ $t(tag.translationKey) }}
  </span>
</template>

<script>
import {TaskTagType} from "@/assets/js/enums/TaskTagType.ts";

export default {
  name: "TaskTag",
  props: {
    type: {
      type: Number,
      required: true
    }
  },
  computed: {
    tag() {
      return TaskTagType.get(this.type);
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.task-tag {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  margin-top: 5px;
  height: 18px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba($tracking-accent, 0.14);
  color: $tracking-accent;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  white-space: nowrap;
}
</style>
